<onsip-header-main>
  <onsip-header-page-title>{{
    "ONSIP_I18N.SAYSO_CALL_HISTORY" | translate
  }}</onsip-header-page-title>
  <onsip-header-action-bar>
    <mat-form-field appearance="outline">
      <input
        matInput
        [formControl]="search"
        [placeholder]="'ONSIP_I18N.SEARCH' | translate"
        autocomplete="off"
      />
      <mat-icon matSuffix color="primary">search</mat-icon>
    </mat-form-field>
  </onsip-header-action-bar>
</onsip-header-main>
<onsip-table-two
  multiTemplateDataRows
  class="org-call-history-table"
  [dataSource]="dataSource"
  [hoverable]="true"
>
  <!-- Date Column -->
  <ng-container matColumnDef="displayDate">
    <mat-header-cell *matHeaderCellDef>{{ "ONSIP_I18N.DATE" | translate }}</mat-header-cell>
    <mat-cell *matCellDef="let call">{{ call.displayDate }}</mat-cell>
  </ng-container>
  <!-- Time Column -->
  <ng-container matColumnDef="time">
    <mat-header-cell *matHeaderCellDef>{{ "ONSIP_I18N.TIME" | translate }}</mat-header-cell>
    <mat-cell *matCellDef="let call">{{ call.time }}</mat-cell>
  </ng-container>
  <!-- Status Column -->
  <ng-container matColumnDef="status">
    <mat-header-cell *matHeaderCellDef>{{ "ONSIP_I18N.STATUS" | translate }}</mat-header-cell>
    <mat-cell *matCellDef="let call">
      <div class="table-cell">
        @if (call.status === ('ONSIP_I18N.ANSWERED' | translate) && call.duration) {
        <span>{{ call.duration | duration }}</span>
        } @else {
        <span class="mat-warn">{{ call.status }}</span>
        }
      </div>
    </mat-cell>
  </ng-container>
  <!-- Agent Column -->
  <ng-container matColumnDef="agent">
    <mat-header-cell *matHeaderCellDef>{{ "ONSIP_I18N.AGENT" | translate }}</mat-header-cell>
    <mat-cell *matCellDef="let call">{{ call.agent }}</mat-cell>
  </ng-container>
  <!-- Feedback Column -->
  <ng-container matColumnDef="feedback">
    <mat-header-cell *matHeaderCellDef>{{ "ONSIP_I18N.FEEDBACK" | translate }}</mat-header-cell>
    <mat-cell *matCellDef="let call">
      <div class="feedback-container">
        <span class="stars">
          <mat-icon [class.filled]="call.feedback >= 5">star</mat-icon>
          <mat-icon [class.filled]="call.feedback >= 4">star</mat-icon>
          <mat-icon [class.filled]="call.feedback >= 3">star</mat-icon>
          <mat-icon [class.filled]="call.feedback >= 2">star</mat-icon>
          <mat-icon [class.filled]="call.feedback >= 1">star</mat-icon>
        </span>
        <mat-icon color="primary"
          >{{ call === expandedElement ? "keyboard_arrow_up" : "keyboard_arrow_down" }}
        </mat-icon>
      </div>
    </mat-cell>
  </ng-container>
  <!-- Expanded -->
  <ng-container matColumnDef="expanded">
    <onsip-table-shelf-cell
      *matCellDef="let element"
      [attr.colspan]="displayedColumns.length"
      [expanded]="element === expandedRow"
    >
      <div class="call-history-details">
        <div class="left-side-details">
          <div class="call-history-detail">
            <span class="detail-title">{{ "ONSIP_I18N.CALLER" | translate }}</span>
            <span class="detail-info">
              @if (hubspotInfo) {
              {{ hubspotInfo.callersName }}
              } @if (!(hubspotInfo && hubspotInfo.callersName)) { N/A }
            </span>
          </div>
          <div class="call-history-detail">
            <span class="detail-title">{{ "ONSIP_I18N.HUBSPOT_OWNER" | translate }}</span>
            <span class="detail-info">
              @if (hubspotInfo) {
              {{ hubspotInfo.hubspotOwner }}
              } @if (!(hubspotInfo && hubspotInfo.hubspotOwner)) { N/A }
            </span>
          </div>
          <div class="call-history-detail">
            <span class="detail-title">{{ "ONSIP_I18N.COMPANY" | translate }}</span>
            <span class="detail-info">
              @if (hubspotInfo) {
              {{ hubspotInfo.companyName }}
              } @if (!(hubspotInfo && hubspotInfo.companyName)) { N/A }
            </span>
          </div>
          <div class="call-history-detail">
            <span class="detail-title">{{ "ONSIP_I18N.PHONE" | translate }}</span>
            <span class="detail-info">
              @if (hubspotInfo) {
              {{ hubspotInfo.phoneNumber }}
              } @if (!(hubspotInfo && hubspotInfo.phoneNumber)) { N/A }
            </span>
          </div>
          <div class="call-history-detail">
            <span class="detail-title">{{ "ONSIP_I18N.EMAIL" | translate }}</span>
            <span class="detail-info">
              @if (hubspotInfo) {
              {{ hubspotInfo.email }}
              } @if (!(hubspotInfo && hubspotInfo.email)) { N/A }
            </span>
          </div>
        </div>
        <div class="right-side-details">
          <div class="right-side-details-container">
            <div class="call-history-detail">
              <span class="detail-title">{{ "ONSIP_I18N.TOPIC" | translate }}</span>
              <span class="detail-info">
                <ng-container>{{ element.topicName }}</ng-container>
              </span>
            </div>
            <div class="call-history-detail">
              <span class="detail-title">{{ "ONSIP_I18N.CALL_ORIGIN" | translate }}</span>
              <a class="detail-info" target="_blank" [href]="element.saysoCallFromLink">
                {{ element.saysoCallFromLink }}
              </a>
            </div>
            <div class="call-history-detail">
              <span class="detail-title">{{ "ONSIP_I18N.CALL_TYPE" | translate }}</span>
              <span class="detail-info">
                @if (!element.video) {
                {{ "ONSIP_I18N.INBOUND_AUDIO" | translate }}
                } @if (element.video) {
                {{ "ONSIP_I18N.INBOUND_VIDEO" | translate }}
                }
              </span>
            </div>
          </div>
        </div>
        <div class="button-container" [class.no-hubspot-info]="!hubspotInfo">
          <div class="action-buttons">
            <button
              mat-button
              class="call-history-button"
              color="primary"
              onsipNewCall
              [contact]="hubspotInfo && hubspotInfo.contact"
              [remoteAor]="hubspotInfo && hubspotInfo.remoteAor"
              [video]="true"
            >
              <mat-icon>videocam</mat-icon>
            </button>
            <button
              mat-button
              class="call-history-button"
              color="primary"
              onsipNewCall
              [contact]="hubspotInfo && hubspotInfo.contact"
              [remoteAor]="hubspotInfo && hubspotInfo.remoteAor"
            >
              <mat-icon>phone</mat-icon>
            </button>
            <button
              mat-button
              class="call-history-button"
              color="primary"
              [onsipAddContact]="hubspotInfo && hubspotInfo.contact"
            >
              <mat-icon>add</mat-icon>
            </button>
          </div>
          <div class="hubspot-link-container">
            <a class="call-history-button" target="_blank" [href]="hubspotPageUrl" tabindex="-1">
              {{ "ONSIP_I18N.SEE_MORE_DETAILS" | translate }}
            </a>
          </div>
        </div>
      </div>
    </onsip-table-shelf-cell>
  </ng-container>
  <ng-container matColumnDef="mobile">
    <cdk-cell *cdkCellDef="let element">
      <div class="mobile-line call-heading">
        <span>{{ "ONSIP_I18N.FROM" | translate }} <b>sayso Caller</b></span>
        <button
          mat-icon-button
          color="primary"
          (menuOpened)="getExpandedDetail(element)"
          [matMenuTriggerFor]="menu"
          [matMenuTriggerData]="{ element: element }"
        >
          <mat-icon>more_vert</mat-icon>
        </button>
      </div>
      <mat-divider></mat-divider>
      <div class="mobile-line">
        <span>{{ "ONSIP_I18N.DATE" | translate }}</span>
        <span class="right">{{ element.displayDate }}</span>
      </div>
      <div class="mobile-line">
        <span>{{ "ONSIP_I18N.TIME" | translate }}</span>
        <span class="right">{{ element.time }}</span>
      </div>
      <div class="mobile-line">
        <span>{{ "ONSIP_I18N.STATUS" | translate }}</span>
        <span class="right">{{ element.status }}</span>
      </div>
      <div class="mobile-line">
        <span>{{ "ONSIP_I18N.AGENT" | translate }}</span>
        <span class="right">{{ element.agent }}</span>
      </div>
      <div class="mobile-line">
        <span>{{ "ONSIP_I18N.TOPIC" | translate }}</span>
        <span class="right">{{ element.topicName }}</span>
      </div>
    </cdk-cell>
    <mat-menu #menu="matMenu">
      <ng-template matMenuContent let-element="element">
        <div [class.no-hubspot-info]="!hubspotInfo">
          <button
            mat-menu-item
            color="primary"
            aria-label="start voice call"
            onsipNewCall
            [contact]="hubspotInfo && hubspotInfo.contact"
            [remoteAor]="hubspotInfo && hubspotInfo.remoteAor"
            [remoteDisplayName]="hubspotInfo && hubspotInfo.callersName"
            class="call-history-button"
          >
            <mat-icon color="primary" onsip-icon-outlined>phone</mat-icon>
            <span>{{ "ONSIP_I18N.CALL_BACK" | translate }}</span>
          </button>
          <button
            mat-menu-item
            color="primary"
            aria-label="start video call"
            onsipNewCall
            [contact]="hubspotInfo && hubspotInfo.contact"
            [remoteAor]="hubspotInfo && hubspotInfo.remoteAor"
            [remoteDisplayName]="hubspotInfo && hubspotInfo.callersName"
            [video]="true"
            class="call-history-button"
          >
            <mat-icon color="primary" onsip-icon-outlined>videocam</mat-icon
            ><span>{{ "ONSIP_I18N.VIDEO_CALL" | translate }}</span>
          </button>
          <button
            mat-menu-item
            color="primary"
            [onsipAddContact]="hubspotInfo && hubspotInfo.contact"
            class="call-history-button"
          >
            <mat-icon color="primary">add_circle_outline</mat-icon>
            <span>{{ "ONSIP_I18N.ADD_CUSTOM_CONTACT" | translate }}</span>
          </button>
        </div>
      </ng-template>
    </mat-menu>
  </ng-container>
  <mat-header-row *matHeaderRowDef="(isMobile | async) ? null : displayedColumns"></mat-header-row>
  <mat-row
    *matRowDef="let row; columns: displayedColumns; when: showDesktopRow.bind(this)"
    (click)="expandedRow = expandedRow === row ? null : row; getExpandedDetail(expandedRow)"
  ></mat-row>
  <onsip-table-shelf
    *matRowDef="let row; columns: ['expanded']; when: showDesktopRow.bind(this)"
  ></onsip-table-shelf>
  <onsip-row *matRowDef="let row; columns: ['mobile']; when: showMobileRow.bind(this)"></onsip-row>
</onsip-table-two>
@if (dataSource.data.length || search.value) {
<div class="page-controls-wrapper">
  @if (askToLoadMore && !isLoading) {
  <div class="load-more-container">
    <span>{{ "ONSIP_I18N.DISPLAY_RESULTS_PAST" | translate }} {{ lastFetchedDate }}</span>
    <button
      id="onsip--org-call-history--keep-searching"
      aria-label="show more search results"
      mat-icon-button
      color="primary"
      (click)="keepSearching()"
    >
      <mat-icon>fast_forward</mat-icon>
    </button>
  </div>
  } @if (isLoading) {
  <div class="pagination-loading">
    <span>{{ "ONSIP_I18N.LOADING" | translate }}...</span>
  </div>
  }
</div>
}
<mat-paginator
  [disabled]="isLoading"
  onsip-paginator-primary-icon
  [length]="dataSource.data.length"
  [showFirstLastButtons]="false"
  [pageSize]="pageSize"
  [pageSizeOptions]="pageSizeOptions"
>
</mat-paginator>
